import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Divider,
  Drawer,
  IconButton,
  Modal,
  Skeleton,
  Switch,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import {
  handleSpringDataMutationRequest,
  handleSpringDataRequest,
} from "../../../api";
import { useState } from "react";
import AddUpdateSpace from "./AddUpdateSpace";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { useHistory } from "react-router-dom";
import meeting_room from "./asset/meeting_room.jpg";
import spa from "./asset/spa.jpg";
import banquet_hall from "./asset/banquet_hall.avif";
import day_rental from "./asset/day_rental.jpeg";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { toast } from "material-react-toastify";

function RentalDashboard() {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    borderRadius: 2,
    border: "1px solid #E0E0E0",
    p: 2,
  };
  const rentalImages = {
    "Meeting Room": meeting_room,
    Spa: spa,
    "Banquet hall": banquet_hall,
    "Day Rental": day_rental,
  };
  const history = useHistory();
  const url = new URL(window.location.href);
  const hotelId = url.searchParams.get("hotelId");
  const [allRentals, setAllRentals] = useState([]);
  const [openAddEditSpace, setOpenAddEditSpace] = useState(false);
  const [selectedRental, setSelectedRental] = useState({});
  const [rentalsLoading, setRentalsLoading] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [globalRentals, setGlobalRentals] = useState([]);

  const getGlobalRentals = () => {
    handleSpringDataRequest(`core/api/v1/non-rental/get-global-non-rental`)
      .then((res) => {
        setGlobalRentals(res);
      })
      .catch(() => {});
  };

  const getAllRentals = () => {
    setRentalsLoading(true);
    handleSpringDataRequest(`core/api/v1/non-rental/get-all-non-rental-type`)
      .then((res) => {
        setAllRentals(res);
      })
      .catch(() => {
        setAllRentals([]);
      })
      .finally(() => {
        setRentalsLoading(false);
      });
  };

  const handleAddSpace = (item) => {
    const payload = {
      id: null,
      globalNonRentalTypeId: item?.id,
      hotelId: hotelId,
      name: item?.name,
      description: item?.description,
      type: item?.name,
      perHourCost: 0,
      taxId: null,
      groupTaxId: null,
      perPersonCost: 0,
      personTaxId: null,
      personGroupTaxId: null,
    };
    setRentalsLoading(true);
    handleSpringDataMutationRequest(
      "POST",
      `core/api/v1/non-rental/create-update-non-rental-type`,
      payload
    )
      .then((res) => {
        getAllRentals();
      })
      .catch(() => {
        setRentalsLoading(false);
        toast.error("Error in adding/updating space.");
      });
  };

  const handleDeleteRental = (selectedRental) => {
    setRentalsLoading(true);
    handleSpringDataMutationRequest(
      "POST",
      `core/api/v1/non-rental/delete-non-rental-type?id=${selectedRental?.id}`,
      {}
    )
      .then((res) => {
        getAllRentals();
      })
      .catch(() => {
        setRentalsLoading(false);
      });
  };

  const handleActivateRental = (selectedRental) => {
    setRentalsLoading(true);
    handleSpringDataMutationRequest(
      "PUT",
      `core/api/v1/non-rental/make-non-rental-type-active?id=${selectedRental?.id}`,
      {}
    )
      .then((res) => {
        getAllRentals();
      })
      .catch(() => {
        setRentalsLoading(false);
      });
  };

  const enableDisableSpace = (item) => {
    const selectedRental = allRentals?.filter(
      (elm) => elm?.globalNonRentalTypeId === item?.id
    );
    if (selectedRental?.[0]?.status === "ACTIVE") {
      handleDeleteRental(selectedRental?.[0]);
    } else if (selectedRental?.[0]?.status === "DELETED") {
      handleActivateRental(selectedRental?.[0]);
    } else {
      handleAddSpace(item);
    }
    // console.log("itemmmm", item, allRentals);
  };

  useEffect(() => {
    getAllRentals();
    getGlobalRentals();
  }, []);
  return (
    <Box sx={{ width: "100%" }}>
      {/* <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          variant="custom-button"
          onClick={() => {
            setOpenAddEditSpace(true);
            setSelectedRental({});
          }}
        >
          Add new space
        </Button>
      </Box> */}
      {/* <Divider sx={{ marginY: 3 }} /> */}

      {rentalsLoading ? (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
          {[1, 2, 3].map((loader) => (
            <Card
              key={loader}
              sx={{ display: "flex", width: "100%", borderRadius: 2, mb: 2 }}
            >
              {/* Image Skeleton */}
              <Skeleton variant="rectangular" width={600} height={200} />

              <Box sx={{ width: "100%", position: "relative" }}>
                {/* Action buttons skeleton (keep icons for layout consistency) */}
                <Box
                  sx={{ position: "absolute", top: 0, right: 0, padding: 1 }}
                >
                  <Switch />
                  {/* <Tooltip title="Delete space">
                    <IconButton disabled>
                      <DeleteOutlineIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Update space">
                    <IconButton disabled>
                      <BorderColorIcon />
                    </IconButton>
                  </Tooltip> */}
                </Box>

                <CardContent sx={{ width: "100%" }}>
                  <Box sx={{ height: "100%" }}>
                    <Typography component="div" variant="h5">
                      <Skeleton width="40%" />
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      component="div"
                      sx={{ color: "text.secondary" }}
                    >
                      <Skeleton width="30%" />
                    </Typography>
                  </Box>
                </CardContent>
              </Box>
            </Card>
          ))}
        </Box>
      ) : (
        // <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
        //   {allRentals
        //     ?.filter((item) => item?.status === "ACTIVE")
        //     .map((item) => (
        //       <Card
        //         sx={{
        //           display: "flex",
        //           width: "100%",
        //           borderRadius: 2,
        //           cursor: "pointer",
        //         }}
        //         onClick={() =>
        //           history.push(
        //             `/space-dashboard/${item?.id}?hotelId=${hotelId}`,
        //             item
        //           )
        //         }
        //       >
        //         <CardMedia
        //           component="img"
        //           sx={{ width: 600, height: 200 }}
        //           image={meeting_room}
        //           alt={item.name}
        //         />
        //         <Box sx={{ width: "100%", position: "relative" }}>
        //           <Box
        //             sx={{ position: "absolute", top: 0, right: 0, padding: 1 }}
        //           >
        //             <Tooltip title="Delete space">
        //               <IconButton
        //                 onClick={(e) => {
        //                   e.stopPropagation();
        //                   setSelectedRental(item);
        //                   setOpenDeleteModal(true);
        //                 }}
        //               >
        //                 <DeleteOutlineIcon />
        //               </IconButton>
        //             </Tooltip>
        //             <Tooltip title="Update space">
        //               <IconButton
        //                 onClick={(e) => {
        //                   e.stopPropagation();
        //                   setSelectedRental(item);
        //                   setOpenAddEditSpace(true);
        //                 }}
        //               >
        //                 <BorderColorIcon />
        //               </IconButton>
        //             </Tooltip>
        //           </Box>
        //           <CardContent sx={{ width: "100%", cursor: "pointer" }}>
        //             <Box
        //               sx={{
        //                 height: "100%",
        //                 textDecoration: "none",
        //                 color: "inherit",
        //               }}
        //             >
        //               <Typography component="div" variant="h5">
        //                 {item.name}
        //               </Typography>
        //               <Typography
        //                 variant="subtitle1"
        //                 component="div"
        //                 sx={{ color: "text.secondary" }}
        //               >
        //                 {item?.type}
        //               </Typography>
        //             </Box>
        //           </CardContent>
        //         </Box>
        //       </Card>
        //     ))}
        // </Box>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
          {globalRentals.map((item) => (
            <Card
              sx={{
                display: "flex",
                width: "100%",
                borderRadius: 2,
                cursor:
                  allRentals?.filter(
                    (elm) => elm?.globalNonRentalTypeId === item?.id
                  )?.[0]?.status === "ACTIVE"
                    ? "pointer"
                    : "not-allowed",
              }}
              onClick={() =>
                allRentals?.filter(
                  (elm) => elm?.globalNonRentalTypeId === item?.id
                )?.[0]?.status === "ACTIVE" &&
                history.push(
                  `/space-dashboard/${item?.id}?hotelId=${hotelId}`,
                  allRentals?.filter(
                    (elm) => elm?.globalNonRentalTypeId === item?.id
                  )?.[0]
                )
              }
            >
              <CardMedia
                component="img"
                sx={{ width: 600, height: 200 }}
                image={meeting_room}
                // image={
                //   rentalImages[item?.type] || toAbsoluteUrl("/media/empty.png")
                // }
                alt={item.name}
              />
              <Box sx={{ width: "100%", position: "relative" }}>
                <Box
                  sx={{ position: "absolute", top: 0, right: 0, padding: 1 }}
                >
                  <Switch
                    onClick={(e) => {
                      e.stopPropagation();
                      enableDisableSpace(item);
                      // setChecked(e.target.checked)
                    }}
                    checked={
                      allRentals?.filter(
                        (elm) => elm?.globalNonRentalTypeId === item?.id
                      )?.[0]?.status === "ACTIVE"
                    }
                    // onChange={(e) => {
                    //   e.stopPropagation();
                    //   setChecked(e.target.checked)
                    // }}
                  />

                  {/* <Tooltip title="Delete space">
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedRental(item);
                      setOpenDeleteModal(true);
                    }}
                  >
                    <DeleteOutlineIcon />
                  </IconButton>
                </Tooltip> */}
                  {/* <Tooltip title="Update space">
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedRental(item);
                      setOpenAddEditSpace(true);
                    }}
                  >
                    <BorderColorIcon />
                  </IconButton>
                </Tooltip> */}
                </Box>
                <CardContent sx={{ width: "100%", cursor: "pointer" }}>
                  <Box
                    sx={{
                      height: "100%",
                      textDecoration: "none",
                      color: "inherit",
                    }}
                  >
                    <Typography component="div" variant="h5">
                      {item.name}
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      component="div"
                      sx={{ color: "text.secondary" }}
                    >
                      {item?.description}
                    </Typography>
                  </Box>
                </CardContent>
              </Box>
            </Card>
          ))}
        </Box>
      )}

      <Drawer
        anchor={"right"}
        open={openAddEditSpace}
        onClose={() => setOpenAddEditSpace(false)}
      >
        <AddUpdateSpace
          allRentals={allRentals}
          selectedRental={selectedRental}
          setOpenAddEditSpace={setOpenAddEditSpace}
        />
      </Drawer>
      <Modal
        open={openDeleteModal}
        onClose={() => setOpenDeleteModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Do you want to delete {selectedRental?.name}?
          </Typography>
          <Box sx={{ mt: 4, display: "flex", justifyContent: "space-between" }}>
            <Button
              variant="outlined"
              onClick={() => setOpenDeleteModal(false)}
              sx={{ textTransform: "none" }}
            >
              Cancel
            </Button>
            <Button variant="custom-button" onClick={handleDeleteRental}>
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}

export default RentalDashboard;
